// How-often gating for marketing campaigns, shared by the popup and the inline
// banner so both honour the admin's "How often" setting identically.
//
//   every_load        -> never gated (shows on every refresh)
//   once_per_session  -> gated once seen this browser session (sessionStorage)
//   once_per_day      -> gated for 24h after last seen (localStorage), default
//
// Keyed per campaign id, so different campaigns cap independently.
const seenKey = (id) => `nos_campaign_seen_${id}`;

export const isGated = (c) => {
  try {
    if (c.frequency === "every_load") return false;
    if (c.frequency === "once_per_session") {
      return sessionStorage.getItem(seenKey(c.id)) === "1";
    }
    // once_per_day (default)
    const ts = Number(localStorage.getItem(seenKey(c.id)) || 0);
    return ts > 0 && Date.now() - ts < 24 * 60 * 60 * 1000;
  } catch {
    return false; // storage unavailable — fail open, still show
  }
};

export const markSeen = (c) => {
  try {
    if (c.frequency === "once_per_session") {
      sessionStorage.setItem(seenKey(c.id), "1");
    } else if (c.frequency !== "every_load") {
      localStorage.setItem(seenKey(c.id), String(Date.now()));
    }
  } catch {
    /* ignore */
  }
};
